import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Book} from "../dto/book";
import {User} from "../dto/user";
import {Schema} from '../dto/schema';
import {Answer} from '../dto/answer';

@Injectable({
    providedIn: 'root'
})
export class AjaxService {

    domainUrl = '';
    book1: Book;
    users: User;
    schema: Schema;
    id = 0;
    allschema;

    constructor(private http: HttpClient) {
        const location:string = document.location + '';
        // console.log('this.domainUrl', this.domainUrl);
        if (-1 !== location.indexOf('localhost')) {
            this.domainUrl = 'http://localhost:8080';
        }
    }

    /**
     * returns answer of registration procedure
     *
     * @param email
     * @param password
     */
    async registerStep1(email, password) {
        const answer = await this.http.get<Answer>(this.domainUrl + '/register?email=' + email + '&pwd=' + password).toPromise();
        return answer;
    }

    async registerStep2(email, password, confirmationCode) {
        const answer = await this.http.get<Answer>(this.domainUrl + '/confirm?email=' + email + '&pwd=' + password + '&code=' + confirmationCode).toPromise();
        return answer;
    }

    async resendCode(email, password) {
        const answer = await this.http.get<Answer>(this.domainUrl + '/resend?email=' + email + '&pwd=' + password).toPromise();
        return answer;
    }

    async removeSchema(schemaId, userId){
        const answer = await this.http.get<Answer>(this.domainUrl + '/removeschema?sid=' + schemaId + '&uid=' + userId).toPromise();
        return answer;
    }


    /**
     * retuens users list
     */
    async sighIn(email, pwd) {
        const usersList = await this.http.get<Answer>(this.domainUrl + '/signin?email=' + email + '&pwd=' + pwd).toPromise();
        // console.log('sighIn', usersList);
        return usersList;
        // const usersList = await this.http.get<User>(this.domainUrl + '/signin?email=' + email + '&pwd=' + pwd).toPromise();
        // return usersList;
    }

    // save scheme by id
    async saveScheme(schemaId, userId = -1000, scheme, name, type) {
        userId = this.id;
        if (userId != -1000) {
            const answer = await this.http.get<Answer>(this.domainUrl + '/saveschemanew?sid=' + schemaId + '&uid=' + userId + '&stext=' + scheme + '&sname=' + name + '&stype=' + type).toPromise();
            return answer;
        } else {
            return null;
        }
    }

    async loadScheme(schemaId) {
        const schema = await this.http.get<Schema>(this.domainUrl + '/getschema?sid=' + schemaId).toPromise();
        return schema;
    }

    //
    async getAllSchema(userId) {
        const schemas = await this.http.get<Schema>(this.domainUrl + '/allschema?uid=' + userId).toPromise();
        return schemas;
    }

    setUserId(id) {
        this.id = id;
    }

    getUserId() {
        return this.id;
    }


}

